import React, { useEffect } from 'react'
import { useAuth } from '@praxis/component-auth'
import {
  getUserAction,
  getUserName,
  getChallengeAuthentication,
} from '../../store/slices/authSlice'
import { useAppDispatch, useAppSelector } from '../../store/hooks'
import { resetStoreAction } from '../../store/resetStore'
import { addAxiosInterceptors } from '../../utils/axios-util'
import Cookies from 'js-cookie'
import { LinearProgress } from '@mui/material/'

export const WithAuthUser = ({
  //passed props
  children,
}) => {
  const auth = useAuth()
  const dispatch = useAppDispatch()
  const userName = useAppSelector(getUserName)
  const challengeAuthentication = useAppSelector(getChallengeAuthentication)

  const { isAuthorized, session, login } = auth
  const isUserAuthorized = isAuthorized()

  useEffect(() => {
    if (isUserAuthorized) {
      if (localStorage.getItem('id_token') === null && session?.accessToken) {
        localStorage.setItem('id_token', session?.accessToken)
      }
      addAxiosInterceptors(dispatch)
      if (
        window.location.host.indexOf('partnersonline') < 0 &&
        session?.userInfo
      ) {
        // if not on partnersonline domain, for testing sake, put a dummy cookie to simulate POL cookie
        Cookies.set(
          'SSOSESSIONINFO',
          btoa(
            JSON.stringify({
              user: session.userInfo.lanId,
              login_status: true,
              debug_timestamp: 1579884083,
            }),
          ),
        )
      }
      if (!userName) {
        dispatch(resetStoreAction)
        dispatch(getUserAction())
      }
    }
  }, [dispatch, isUserAuthorized, userName, isAuthorized, session])

  useEffect(() => {
    if (challengeAuthentication) {
      localStorage.removeItem('id_token')
      localStorage.removeItem('access_token')
      window.location.reload()
    }
  }, [challengeAuthentication])

  return (
    <>
      {!userName && <LinearProgress />}
      {isUserAuthorized && userName && !challengeAuthentication
        ? children
        : login()}
    </>
  )
}
